module.exports = __webpack_public_path__ + "de77a722/img/menu-icon.5f8facae.svg";